import { Image } from "antd";

export default Image;